import Cookies from 'js-cookie';
var TokenKey = 'Token';
var Info = 'Info';

// Token 操作（原有逻辑无需修改）
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}

// ========== 核心修改：用户信息操作 ==========
export function setUserInfo(userInfo) {
  // 关键：存储前必须序列化 JSON（否则存的是 [object Object]）
  return Cookies.set(Info, JSON.stringify(userInfo));
}
export function getUserInfo() {
  // 关键：读取后必须解析 JSON，且做容错处理
  var info = Cookies.get(Info);
  if (!info) return '';
  try {
    return JSON.parse(info); // 解析为对象，方便直接取 .username
  } catch (e) {
    console.error('用户信息解析失败:', e);
    return '';
  }
}
export function removeUserInfo() {
  return Cookies.remove(Info);
}